import { ModeHalResource, DataViewTypes } from '@mode/shared/contract-common';

export const QUERY_RUN_RESOURCE_PROPERTIES = [
  'created_at',
  'data_source_id',
  'error_code',
  'error_message',
  'error_type',
  'help_url',
  'id',
  'limit',
  'max_result_bytes',
  'parameters',
  'query_created_at',
  'query_name',
  'query_token',
  'raw_source',
  'rendered_source',
  'state',
  'statement_annotation',
  'token',
  'dbt_metric_token',
  'dbt_metric_id',
];

export interface QueryRunResource extends ModeHalResource {
  query_token: string;
  source: string;
  raw_source: string;
  limit: boolean;
  rendered_source: string;
  state: DataViewTypes.QueryRunStatus;
  layout: string;
  data_source_id: string;
  completed_at: string;
  startedAt: string;
  created_at: string;
  error_code?: string;
  error_type?: string;
  error_message: string;
  help_url?: string;
}
